import { Box, type BoxProps, Divider, Stack } from "@chakra-ui/react"
import type { ReactNode } from "react"

type DocumentHeaderSectionProps = BoxProps & {
  bg?: string
  children: ReactNode
  summary?: ReactNode
  meta?: ReactNode
  metaPlacement?: "bottom" | "right"
}

export default function DocumentHeaderSection({
  bg,
  children,
  summary,
  meta,
  metaPlacement = "bottom",
  ...rest
}: DocumentHeaderSectionProps) {
  const rightMeta = metaPlacement === "right" ? meta : null
  const bottomMeta = metaPlacement === "bottom" ? meta : null

  if (summary || rightMeta) {
    return (
      <Box borderWidth="1px" borderRadius="md" p={3} bg={bg} mb={4} {...rest}>
        <Box
          display="grid"
          gridTemplateColumns={{
            base: "1fr",
            xl:
              summary && rightMeta
                ? "minmax(0, 1fr) minmax(240px, 320px) 240px"
                : "minmax(0, 1fr) 320px",
          }}
          gap={4}
          alignItems="start"
        >
          <Stack spacing={1.5}>
            {children}
            {bottomMeta ? (
              <>
                <Divider my={1.5} />
                {bottomMeta}
              </>
            ) : null}
          </Stack>
          {rightMeta ? (
            <Box
              borderLeftWidth={{ base: "0", xl: "1px" }}
              borderTopWidth={{ base: "1px", xl: "0" }}
              pl={{ base: 0, xl: 4 }}
              pt={{ base: 3, xl: 0 }}
            >
              {rightMeta}
            </Box>
          ) : null}
          {summary ? (
            <Box
              borderLeftWidth={{ base: "0", xl: "1px" }}
              borderTopWidth={{ base: "1px", xl: "0" }}
              pl={{ base: 0, xl: 4 }}
              pt={{ base: 3, xl: 0 }}
            >
              {summary}
            </Box>
          ) : null}
        </Box>
      </Box>
    )
  }

  return (
    <Box borderWidth="1px" borderRadius="md" p={3} bg={bg} mb={4} {...rest}>
      <Stack spacing={1.5}>
        {children}
        {bottomMeta ? (
          <>
            <Divider my={1.5} />
            {bottomMeta}
          </>
        ) : null}
      </Stack>
    </Box>
  )
}
